export const LocalStorageKey = 'responseCode';
export const ResumeUrlParam = 'autoresume';
export const ClarificationClassName = 'clarification';
export const ClarificationClass = `.${ClarificationClassName}`;
export const ContinueUrl = '/questionnaire?autoresume=true';
export const ContentType = 'application/json';
export const FixedElementHeight = 80;

export enum ApiUrls {
	QuestionnaireStart = '/api/questionnaire/start',
	QuestionAnswer = '/api/question/answer',
	QuestionOpen = '/api/question/open',
	ReportOpen = '/api/report/open',
	QuestionnaireOpen = '/api/questionnaire/open',
	ClarificationOpen = '/api/clarification/open',
	Questionaire = '/api/questionnaire',
}
